import { render, staticRenderFns } from "./Input-Comment.vue?vue&type=template&id=022bf530&lang=pug"
import script from "./Input-Comment.vue?vue&type=script&lang=ts"
export * from "./Input-Comment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports